'use client';

import React__default from 'react';
import { useCalendar } from '../../context/calendar.js';
import { CalendarGrid, CalendarItem } from '../../styles.css.js';
import { ECalendarType } from '../../types.js';
import { getFullYear, getMonth, getDate, handleActiveItem, getNewDate } from '../../utils/calendar.js';
import { FIRST_MONTH, FIRST_DAY } from '../../const.js';

function DecadePanel(_a) {
    var currentDate = _a.currentDate;
    var currentYear = getFullYear(currentDate);
    var yearNow = getFullYear(new Date());
    var _b = useCalendar(), type = _b.type, calendarType = _b.calendarType, setCalendarType = _b.setCalendarType, selectedDates = _b.selectedDates, handleDatesClick = _b.handleDatesClick, minDate = _b.minDate, maxDate = _b.maxDate, year = _b.year, setSelectedDates = _b.setSelectedDates, setCurrentDate = _b.setCurrentDate;
    var today = new Date(yearNow, FIRST_MONTH, FIRST_DAY);
    var startYear = year - 6; // Show 12 years: 6 before and 6 after the current year
    var endYear = startYear + 11;
    var years = [];
    for (var i = startYear; i <= endYear; i++) {
        years.push(i);
    }
    var getNewSeletedDates = function () {
        var selectedYears = [];
        if (!selectedDates || (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length) < 1) {
            selectedYears = [new Date(currentYear, FIRST_MONTH, FIRST_DAY)];
        }
        if ((selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length) === 1) {
            selectedYears = [getNewDate(selectedDates[0], ECalendarType.decade)];
        }
        if ((selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length) === 2) {
            selectedYears = [
                getNewDate(selectedDates[0], ECalendarType.decade),
                getNewDate(selectedDates[1], ECalendarType.decade)
            ];
        }
        return selectedYears;
    };
    var onClickYear = function (year) {
        if (type === calendarType) {
            handleDatesClick(year);
            return;
        }
        switch (selectedDates === null || selectedDates === void 0 ? void 0 : selectedDates.length) {
            case 1:
                setSelectedDates([new Date(getFullYear(year), getMonth(selectedDates[0]), getDate(selectedDates[0]))]);
                break;
            case 2:
                setSelectedDates([new Date(getFullYear(year), getMonth(selectedDates[1]), getDate(selectedDates[1]))]);
                break;
        }
        setCurrentDate(new Date(getFullYear(year), getMonth(currentDate), getDate(currentDate)));
        setCalendarType(ECalendarType.year);
    };
    return (React__default.createElement(CalendarGrid, { type: ECalendarType.decade }, years.map(function (item, _) {
        var year = selectedDates && selectedDates.length > 0
            ? new Date(item, getMonth(selectedDates[0]), getDate(selectedDates[0]))
            : new Date(item, FIRST_MONTH, FIRST_DAY);
        var _a = handleActiveItem(getNewSeletedDates(), year), isActiveEnd = _a.isActiveEnd, isActiveStart = _a.isActiveStart, isInRangeActive = _a.isInRangeActive;
        var isDisabled = (minDate && year < minDate) || (maxDate && year > maxDate);
        return (React__default.createElement(CalendarItem, { key: item, type: ECalendarType.decade, active: isActiveEnd || isActiveStart ? 1 : 0, inRangeActive: isInRangeActive ? 1 : 0, disable: isDisabled ? 1 : 0, onClick: function () { return onClickYear(year); }, today: today.toDateString() === year.toDateString() && !isInRangeActive ? 1 : 0 },
            React__default.createElement("span", null,
                " ",
                item)));
    })));
}

export { DecadePanel as default };
//# sourceMappingURL=decadePanel.js.map
